import { PropsWithChildren } from 'react';

interface LinkWrapperProps {
  link?: string;
}

const LinkWrapper = ({ children, link }: PropsWithChildren<LinkWrapperProps>) =>
  link ? (
    <a href={link} rel="noreferrer" target="_blank">
      {children}
    </a>
  ) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  );

export default LinkWrapper;
